import { SET_EDIT_PROFILE } from '../types'
export default (state = false, action) => {
  switch (action.type) {
    case SET_EDIT_PROFILE:
      return action.payload
    default:
      return state;
  }
}